import React from 'react';
import styles from './inventory.module.css';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { faIR } from '@mui/x-data-grid/locales';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';


export default function InventoryTable({ rows, columns, isLoading }) {

  const [filterModel, setFilterModel] = React.useState({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [''],
  });

  const handleFilterModelChange = React.useCallback(
    (newModel) => setFilterModel(newModel),
    [],
  );

  const existingTheme = useTheme();
  const theme = React.useMemo(() => createTheme({}, faIR, existingTheme, { direction: 'rtl', }), [existingTheme],);

  return (
    <ThemeProvider theme={theme}>
      <DataGrid
        sx={{ width: '100%', minWidth: '768px', direction: 'ltr', fontFamily: 'iranSans', userSelect: 'none', "& .MuiDataGrid-row:hover": { backgroundColor: "rgb(249, 214, 157)",} }}
        rows={rows}
        columns={columns}
        initialState={{
          filter: { filterModel, },
        }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableColumnResize
        hideFooter
        loading={isLoading}
        getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? `${styles.even}` : `${styles.odd}`}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: { showQuickFilter: true, printOptions: { disableToolbarButton: true }, csvOptions: { disableToolbarButton: true } },
        }}
        filterModel={filterModel}
        onFilterModelChange={handleFilterModelChange}
      />
    </ThemeProvider>
  )
}
